// Misc
import React from 'react'
import PropTypes from 'prop-types'

// Atoms
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import CardActions from '@material-ui/core/CardActions'
import Typography from '@material-ui/core/Typography'
import { LinkButton } from 'atoms/Link'
import CenteredCard from 'atoms/CenteredCard'

// Icons
import ErrorIcon from '@material-ui/icons/Error'

const ErrorCard = ({ primary, secondary, actions, withHomeAction }) => {
  const showActions = !!actions || !!withHomeAction
  return (
    <CenteredCard>
      <List>
        <ListItem>
          <ListItemIcon>
            <ErrorIcon color="error" />
          </ListItemIcon>
          <ListItemText
            disableTypography
            primary={<Typography variant="body1" color="error">{ primary }</Typography>}
            secondary={secondary && <Typography color="textSecondary">{ secondary }</Typography>}
          />
        </ListItem>
      </List>
      { showActions
        && (
        <CardActions>
          { !!withHomeAction
            && (
            <LinkButton to="/" size="small" color="secondary">
              Home Page
            </LinkButton>
            )
          }
          { actions }
        </CardActions>
        )
      }
    </CenteredCard>
  )
}

ErrorCard.propTypes = {
  primary: PropTypes.any,
  secondary: PropTypes.any,
  actions: PropTypes.any,
  withHomeAction: PropTypes.bool,
}

export default ErrorCard
